import CryptoJS from "crypto-js";

/**
 * AI面试加解密工具
 */
export const Crypto = {
  /**
   * 获取加密用的密钥
   * @private
   */
  _getEncryptKey() {
    // 使用Base64编码隐藏密钥
    const encoded = "YzFiMmFiNDgyYjVlNDk5NA==";
    const decoded = atob(encoded);
    return CryptoJS.enc.Utf8.parse(decoded);
  },

  /**
   * 获取加密用的IV
   * @private
   */
  _getEncryptIv() {
    // 使用Base64编码隐藏IV
    const encoded = "YmQzYmFkYTk5NDJiYzQxOA==";
    const decoded = atob(encoded);
    return CryptoJS.enc.Utf8.parse(decoded);
  },

  /**
   * 加密请求参数数据用于makeQuestions接口
   * @param data 需要加密的数据对象
   * @returns 十六进制格式的加密字符串
   */
  encryptData(data: any) {
    // 1. 获取混淆处理后的密钥和IV
    const key = this._getEncryptKey();
    const iv = this._getEncryptIv();

    // 2. 将数据转为JSON字符串
    const jsonStr = JSON.stringify(data);

    // 3. 使用AES-CBC加密
    const encrypted = CryptoJS.AES.encrypt(jsonStr, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // 4. 将加密结果转为十六进制字符串
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  }
};
